import React, { Component } from 'react';

class SeriesModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            selectAll: false
        };
    }
    onChangeField = (keyVal, value) => {
        this.setState({
            [keyVal]: value
        })
    }
    render() {
        const { action, adminUsersModel, checkbox, editMode, SaveSeries, CloseSeriesModal } = this.props;
        const useSeriesAndConsecutives = (adminUsersModel?.newSeries?.[0]?.Remark ?? '') == 'SERIES'
        const listWithIndex = (adminUsersModel.newSeries || [])
            .map((s, i) => ({ ...s, __origIndex: i }));

        const filtered = listWithIndex.filter(s =>
            s.SeriesName?.toLowerCase().includes(this.state.search.toLowerCase()) ||
            (s.Series + "").includes(this.state.search)
        );
        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="seriesModal" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="seriesModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Series</h4>
                            &nbsp;
                            <button type="button" className="close" onClick={CloseSeriesModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="col-12 d-flex align-items-center">
                                            <input
                                                type="text"
                                                className="form-control mb-2 mr-2"
                                                placeholder="Buscar serie..."
                                                value={this.state.search}
                                                onChange={(e) => this.onChangeField('search', e.target.value)}
                                            />
                                            <div className="form-check p-0 m-0 mb-1 d-flex align-items-center">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input align-self-center"
                                                    id="checkSelectAll"

                                                    checked={this.state.selectAll ?? false}
                                                    onChange={(e) => {
                                                        this.onChangeField('selectAll', e.target.checked);
                                                        checkbox.checkAll(e.target.checked);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <tr>
                                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Nombre serie</td>
                                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Número serie</td>
                                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Número siguiente</td>

                                                    <td className="sticky-header table-header-yellow"
                                                        style={{ width: 50, textAlign: "center" }}>
                                                    </td>
                                                    {useSeriesAndConsecutives &&
                                                        <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Default</td>}
                                                </tr>
                                                {filtered.map((serie, index) => {
                                                    return (
                                                        <tr key={serie.__origIndex ?? index}>
                                                            <td style={{ textAlign: "center" }}>{serie.SeriesName}</td>
                                                            <td style={{ textAlign: "center" }}>{serie.Series}</td>
                                                            <td style={{ textAlign: "center" }}>{serie.NextNumber}</td>

                                                            <td className="sticky-column">
                                                                <input
                                                                    type="checkbox"
                                                                    disabled={(action === 2 && !editMode) ? true : false}
                                                                    checked={serie.selected}
                                                                    style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                    onChange={() => checkbox.selectOne(serie.__origIndex ?? index, 2)} />
                                                            </td>
                                                            {useSeriesAndConsecutives &&
                                                                <td className="sticky-column">
                                                                    <input
                                                                        type="radio"
                                                                        disabled={(action === 2 && !editMode) ? true : false}
                                                                        checked={serie?.default ?? false}
                                                                        style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                        onChange={() => checkbox.selectOne(serie.__origIndex ?? index, 3)} />
                                                                </td>
                                                            }
                                                        </tr>
                                                    )
                                                })}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={CloseSeriesModal}>
                                Cerrar
                            </button>
                            {action === 1 && !editMode &&
                                <button type="button" className="btn botonCorrect"
                                    onClick={SaveSeries}>
                                    Guardar
                                </button>
                            }
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect"
                                    onClick={SaveSeries}>
                                    Actualizar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SeriesModal;